import { Discount, Pricing } from '../pricing-offer/pricingOffer';
import { OfferSession } from '../session/session';
import { Tag } from '../tags/tag';
import { TraineeFullOffer } from '../trainee/trainee';
import { Universe } from '../universe/universe';

export class FullOffer {
  offerBasketKey?: number;
  sessionBasketKey?: number;
  sessionKey?: number;
  offerKey?: number;
  offerName?: string;
  clubCode?: string;
  clubName?: string;
  image?: string;
  oldImage?: string;
  practicePlace?: string;
  practicePlaceKey?: number;
  fullPracticePlace?: any;
  description?: string;
  offerClubURL?: string;
  customerPromise?: string;
  duration?: string;
  openingPeriod?: string;
  informations?: string;
  services?: string;
  environment?: string;
  prerequisites?: string;
  price?: string;
  fixedPrice?: number;
  calculatedPrice?: number;
  nettoPrice?: number;
  quantityPrice?: number;
  advancePayment?: number;
  isPayableAtClub?: boolean;
  isPayableOnline?: boolean;
  isActive?: boolean;
  isComplete?: boolean;
  memoMessageUser?: string;
  cityUser?: string;
  postalCodeUser?: string;
  licenceUser?: string;
  ageUser?: number;
  birthdateUser?: string;
  quantity?: number;
  parametersValues?: string;
  tags?: Tag[];
  mainTags?: Tag[];
  advantage?: string;
  photoExperience?: string;
  photoExperienceBas?: string;
  universes?: Universe[];
  parameters?: any[];
  parametersFirstPage?: any[];
  parametersSecondPage?: any[];
  bookedOfferRecordDate?: string;
  bookedOfferStatus?: string;
  ressources?: string;
  isPriority?: boolean;
  tagsNumber?: number;
  latitude?: number;
  longitude?: number;
  distance?: number;
  isSelected?: boolean;
  discount?: Discount[];
  pricing?: Pricing[];
  sessions?: OfferSession[];
  sessionTotalPrice?: number;
  traineeQuantity?: number;
  trainees?: TraineeFullOffer[];
  hasSession?: boolean;
  isExternalOffer?: boolean;
  licenceRequired?: boolean;
  picture?: boolean;
  offerSessionSettable?: boolean;
  offerParameterUpdatable?: boolean;
  licenceKey?: number;
  isLicence?: boolean;
  userKey?: number;
  rating?: number;
  ratingTotal?: number;
  startDate?: any;
  endDate?: any;
  articleType?: string;
  disciplines?: Discipline[];
  places?: ArticlePlace[];
  ownerKey?: number;
  actionName?: string;
  discipline?: string;
  updatedOn?: any;
  disciplinePicture?: any;
  writer?: string;
  formDefinitionKey?: number;
	placeUsed?: number;
	placeFree?: number;
	placeTotal?: number;

  constructor(data?: FullOffer) {
      this.isExternalOffer = data?.isExternalOffer || false;
      this.image = data?.image || null;
  }

}

export class ImageOffer {
    picture: string;
    pictureBase64: string;
}

export class Discipline {
  key: number;
  actorKey?: number;
  articleKey: number;
  label: string
}

export class ArticlePlace {
  key: number;
  articleKey: number;
  latitude: number;
  longitude: number;
  distance: number;
  postalCode: string;
  city: string;
  department: string;
  region: string;
  country: string;
  address: string;
  box: string;
}



